export default class Overlay {
    constructor() {
        this.$el = document.querySelector('[data-wrapper-disable]');

        this.open = this.open.bind(this);
        this.close = this.close.bind(this);
    }

    open() {
        this.$el.classList.add('wrapper-disable--open')
    }

    close() {
        this.$el.classList.remove('wrapper-disable--open')
    }
}